"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.promotionValidationService = void 0;
var PromotionValidationService_1 = require("./implementation/PromotionValidationService");
exports.promotionValidationService = new PromotionValidationService_1.PromotionValidationService();
//# sourceMappingURL=index.js.map